module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_family_photowedding-1d133338374142ed0712aad17f95cf91.webp";